import React, { FC } from 'react'
import { CheckWithElement } from 'Pages/landings/newLandings/common/components'
import { Wrapper, Block, Title, Info, Text } from './styled'

export const BenefitsComponent: FC = () => (
	<Wrapper>
		<Block>
			<Title>От чего зависит ставка</Title>
			<Info>
				На ставку влияет оборот и количество терминалов. Чем больше продаёте, тем меньше платите
				банку. Ставка пересчитывается автоматически каждый месяц.
			</Info>
		</Block>
		<Block>
			<Title>Что не влияет на ставку</Title>
			<CheckWithElement text={() => <Text>Платёжная система</Text>} />
			<CheckWithElement text={() => <Text>Банк, где была выпущена карта</Text>} />
			<CheckWithElement text={() => <Text>Статус карты — платиновая или обычная</Text>} />
		</Block>
	</Wrapper>
)
